import { LuSendHorizontal } from 'react-icons/lu';


const ListCustomized = ({ items }) => {

  const splitList = (item) => {
    if (item.indexOf(":") > -1) {
      const splitItem = item.split(":");
      if (splitItem.length === 2)
        return <><strong>{splitItem[0]}:</strong>{splitItem[1]}</>;
    }
    return item;
  }

  return (
    <ul className="experience-list">
      {items.map((item, index) => ( 
        <li key={index}>
          <LuSendHorizontal className="list-icon" />
          <span>{splitList(item)}</span>
        </li>
      ))}
    </ul>
  );
};

export default ListCustomized;